import { api } from "../App";
import {
  SET_COMMON_ADMINISTRATION,
  SET_COMMON_BASIC_ACTIVITY,
  SET_COMMON_CLASSES,
  SET_COMMON_CLASSES_BY_YEAR,
  SET_COMMON_COUNTRIES,
  SET_COMMON_COURSES,
  SET_COMMON_EXAM_TYPES,
  SET_COMMON_FAMILY_COMPOSITION,
  SET_COMMON_FAMILY_STATUSES,
  SET_COMMON_LANGUAGES,
  SET_COMMON_LOADING,
  SET_COMMON_PARALLELS,
  SET_COMMON_SCHEDULE_VARIANTS,
  SET_COMMON_SCHOOLS,
  SET_COMMON_SCHOOL_YEARS,
  SET_COMMON_SHIFTS,
  SET_COMMON_SPECIALIZATIONS,
  SET_COMMON_STUDY_FORMS,
  SET_COMMON_STUDY_MODES,
  SET_COMMON_STUDY_PROFILES,
  SET_COMMON_STUDY_STEPS,
  SET_COMMON_SUBJECTS,
  SET_COMMON_TEACHERS_LIST,
  SET_COMMON_TERM_GRADE_TYPES,
  SET_COMMON_TERM_TYPES,
  SET_COMMON_LESSONS,
  SET_COMMON_WORKER_TYPES,
  SET_COMMON_KIND_WORK,
  SET_COMMON_TEACHER_ATTESTATION,
  SET_COMMON_STAFF_POSITION_GUK,
  SET_COMMON_OKIN,
  SET_COMMON_YEAR_GRADE_TYPES,
} from "./types";
import { createNotification } from "../components/Notifications/Notifications";
import { getGroups } from "./groups";
import { SET_CLASSING_PAGE } from "./types";




export const getTeachersList = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/teachers`);
    dispatch({ type: SET_COMMON_TEACHERS_LIST, payload: data.teachers });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getSchoolYears = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/school_year`);
    dispatch({ type: SET_COMMON_SCHOOL_YEARS, payload: data.school_year });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getSpecializations = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/specializations`);
    dispatch({ type: SET_COMMON_SPECIALIZATIONS, payload: data.specializations });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getLanguages = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/languages`);
    dispatch({ type: SET_COMMON_LANGUAGES, payload: data.language });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getStudyProfiles = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/track_profile`);
    dispatch({ type: SET_COMMON_STUDY_PROFILES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getStudyModes = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/study_modes`);
    dispatch({ type: SET_COMMON_STUDY_MODES, payload: data.study_mode });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getStudyForms = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/study_forms`);
    dispatch({ type: SET_COMMON_STUDY_FORMS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getStudySteps = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/study_steps`);
    dispatch({ type: SET_COMMON_STUDY_STEPS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};
//совпадает с  import { getStagesStudy } from '../../actions/stagesStudy'

export const getShifts = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/shifts`);
    dispatch({ type: SET_COMMON_SHIFTS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getCountries = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/countries`);
    dispatch({ type: SET_COMMON_COUNTRIES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getSubjects = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/subjects`);
    dispatch({ type: SET_COMMON_SUBJECTS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getSchools = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/schools`);
    dispatch({ type: SET_COMMON_SCHOOLS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getFamilyStatuses = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/family_status`);
    dispatch({ type: SET_COMMON_FAMILY_STATUSES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getFamilySocialComposit = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/family_social_composition/types_to_values`);
    dispatch({ type: SET_COMMON_FAMILY_COMPOSITION, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getTermTypes = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/term_types`);
    dispatch({ type: SET_COMMON_TERM_TYPES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getTermGradeTypes = (terms) => async (dispatch, getState) => {
  //  terms учеб периоды 4 шт 561
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/term_grade_types${terms ? terms : ''}`);
    dispatch({ type: SET_COMMON_TERM_GRADE_TYPES, payload: data.term_grade_types });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};
export const getYearGradeTypes = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/year_grade_types`);
    dispatch({ type: SET_COMMON_YEAR_GRADE_TYPES, payload: data.year_grade_types });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const getAdminisList = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMMON_LOADING, payload: true });
  try {
    const { data } = await api.get(`/admin`);
    dispatch({ type: SET_COMMON_ADMINISTRATION, payload: data.admin });
  } catch (error) {
  } finally {
    dispatch({ type: SET_COMMON_LOADING, payload: false });
  }
};

export const deleteGroup = (groupsId) => async (dispatch, getState) => {
  try {
    await api.delete(`/groups/${groupsId}`);
    createNotification('success', 'Успешно');
    dispatch({ type: SET_CLASSING_PAGE, payload: { pageNumber: 0 } });
    await dispatch(getGroups());
  } catch (error) {
    createNotification('error', 'Ошибка');
  }
};

export const getParallels = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/parallel`);
    dispatch({ type: SET_COMMON_PARALLELS, payload: data });
  } catch (error) {
  }
};

export const getCLasses = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/scheduling/classes`);
    dispatch({ type: SET_COMMON_CLASSES, payload: data });
  } catch (error) {
  }
};
export const getCLassesByYear = (xp_key) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams({ xp_key }).toString();
    const { data } = await api.get(`/scheduling/classes?${urlParams}`);
    dispatch({ type: SET_COMMON_CLASSES, payload: data });
  } catch (error) {
  }
};

// Получить классы по параллели (year)
export const getClassesByYear = (year) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/scheduling/classes?year=${year}`);
    dispatch({ type: SET_COMMON_CLASSES, payload: data });
  } catch (error) {
  }
};
// КЛАССЫ ПО ГОДУ
export const getSchoolClassByYear = (xp_key) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(xp_key).toString();
    const { data } = await api.get(`/school_class?${urlParams}`);
    dispatch({ type: SET_COMMON_CLASSES_BY_YEAR, payload: data });
  } catch (error) {
  }
};

export const getScheduleVariants = (yearId) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/schedule_variant?type=0&school_year_id=${yearId}`);
    dispatch({ type: SET_COMMON_SCHEDULE_VARIANTS, payload: data.schedule_variants });
  } catch (error) {
  }
};

export const getExamTypes = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/exam_schedule_type`);
    dispatch({ type: SET_COMMON_EXAM_TYPES, payload: data });
  } catch (error) {
  }
};

export const getCourses = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/courses/active`);
    dispatch({ type: SET_COMMON_COURSES, payload: data.courses });
  } catch (error) {
  }
};

// используется в EducationalMethodologicalKits
export const getLessons = () => async (dispatch, getState) => {
  try {
    // дефолтный limit на сервере — 100, справочник нужен целиком
    const { data } = await api.get(`/lessons?limit=9999`);
    dispatch({ type: SET_COMMON_LESSONS, payload: data.lessons });
  } catch (error) {
  }
};

export const getBasicActivity = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/library/health/basic_activities`);
    dispatch({ type: SET_COMMON_BASIC_ACTIVITY, payload: data });
  } catch (error) {
  }
};

///////////////////////// ТИПЫ РАБОТНИКОВ Кадровый состав /////////////////////////
export const getWorkerTypes = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/pers_type`);
    dispatch({ type: SET_COMMON_WORKER_TYPES, payload: data?.pers_type_list });
  } catch (error) {
  }
};


///////////////////////// Штатная должность ГУКа Кадровый состав /////////////////////////
export const getStaffPositionGuk = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/phone_book_entry`);
    dispatch({ type: SET_COMMON_STAFF_POSITION_GUK, payload: data?.phone_book_entry_list });
  } catch (error) {
  }
};
///////////////////////// Должность Кадровый состав /////////////////////////
export const getTeacherAttestation = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/teacher-attestation`);
    dispatch({ type: SET_COMMON_TEACHER_ATTESTATION, payload: data?.teacher_attestation_list });
  } catch (error) {
  }
};
///////////////////////// Вид работы Кадровый состав /////////////////////////
export const getKindWork = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/kind_work`);
    dispatch({ type: SET_COMMON_KIND_WORK, payload: data?.kind_work_list });
  } catch (error) {
  }
};
///////////////////////// ОКИН Кадровый состав /////////////////////////
export const getOKIN = (okinCode) => async (dispatch, getState) => {
  // Коды: 02 — гражданство, 04 — языки, 05 — степень владения языком, 10 — состояние в браке, 11 — родство.
  try {
    const { data } = await api.get(`/okin?razdel_code=${okinCode}`);
    dispatch({ type: SET_COMMON_OKIN, payload: data?.calc_data });
  } catch (error) {
  }
};


